import api from './api';

export const shareService = {
  async createShareToken(entryId, shareData) {
    const response = await api.post(`/share/${entryId}`, shareData);
    return response.data;
  },

  async getSharedEntry(token) {
    const response = await api.get(`/shared/${token}`);
    return response.data;
  },

  async revokeShareToken(token) {
    const response = await api.delete(`/share/${token}`);
    return response.data;
  },

  async getViewLogs(entryId) {
    const response = await api.get(`/share/logs/${entryId}`);
    return response.data;
  },

  async getUserShares() {
    const response = await api.get('/share/user-shares');
    return response.data;
  },
};
